export const linkDataTypes = [
  'DocumentLink',
  'EmailLink',
  'ExternalLink',
  'PageLink',
  'DynamicPageLink',
  'TpaPageLink',
  'PhoneLink',
  'WhatsAppLink',
  'AddressLink',
  'LoginToWixLink',
  'AnchorLink',
] as const;

export const linkDataTarget = ['_self', '_blank'] as const;

export const ELEMENT_TYPE = '$w.AccountNavBar';
